export const FORM_SCHEMA_QUERY_PARAMS = {
  formType: 'formType',
  schemaName: 'schemaName',
  schemaVersion: 'schemaVersion',
  section: 'section',
} as const;
